import * as React from "react"
import { AppTableSeeker } from "@components"
import {isEmpty} from "@ui-seeker/utils";

import {TABS_TABLE} from "../../@contants";
import {usePriceEvolutionTableMinMax} from "../../@hooks";
import {PriceEvolutionTabsTableID} from "../../@signals";
import PriceEvolutionTableLoadingBlock from "../TablePricing/LoadingBlock";
import {
	dateColumn,
	distributionRetailerColumn,
	distributionSkuColumn,
	minMaxFiltersColumn,
	productSkuColumn,
	referenceDiscountColumn,
	referencePriceColumn,
	retailerColumn,
	imageColumn
} from "./columns";
import PriceEvolutionTableMinMaxActions from "./Actions";


export default function PriceEvolutionTableMinMax() {
    const { allData, isLoading, currentData, isPercentage, tableMetric, isSplitBySku, selectedLabel, handleExcel, handleChangeMetric } = usePriceEvolutionTableMinMax()

	if (isLoading)
		return <PriceEvolutionTableLoadingBlock />
		
    if (isEmpty(allData))
		return <></>
    if (PriceEvolutionTabsTableID.value !== TABS_TABLE.MIN_MAX)
		return <></>

	const referenceColumn = isPercentage ? referenceDiscountColumn : referencePriceColumn
	const distributionColum = (sort, name, label) => isSplitBySku
		? distributionRetailerColumn(sort, name, label)
		: distributionSkuColumn(sort, name, label)

    return <AppTableSeeker
		sx={{ display: '' }}
		data={currentData}
		title={`${isPercentage ? 'DISCOUNT' : 'PRICE'} Min/Max details - ${selectedLabel}`}
		subtitle="Please note all calculations are unweighted"
		columns={[
			dateColumn(tableMetric),
			...isSplitBySku ? [imageColumn()] : [],
			...isSplitBySku ? productSkuColumn() : retailerColumn(),
			...minMaxFiltersColumn(),
			referenceColumn('minRef', 'Min.'),
			...distributionColum('numMin', 'minData', isSplitBySku ? 'Min. Retailers' : 'Min. SKUs'),
			referenceColumn('maxRef', 'Max.'),
			...distributionColum('numMax', 'maxData', isSplitBySku ? 'Max. Retailers' : 'Max. SKUs')
		]}
		options={{
			customToolbar: () => <PriceEvolutionTableMinMaxActions
				tableMetric={tableMetric}
				handleChangeMetric={handleChangeMetric}
			/>,
			onDownload: handleExcel
		}}
	/>

}